import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { customTheme } from '../../theme/custom-theme.jsx';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSession, clearSession } from "../../store/reducers/sessionReducer";
import { fetchAuthSession } from "../../api/auth";
import { redirectToAuth } from "../../api/http";
import Mobile from '../Mobile/Mobile';

import MainPage from '../MainPage/MainPage';
import Auth from '../Auth/Auth';

function App() {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        localStorage.removeItem('id');
      } catch {
        /* ignore */
      }

      const onAuthPage =
        typeof window !== 'undefined' &&
        (window.location.pathname === '/auth' ||
          window.location.pathname.startsWith('/auth/'));

      const result = await fetchAuthSession();
      if (cancelled) return;

      if (result.status === 'ok') {
        dispatch(setSession(result.data));
        return;
      }

      dispatch(clearSession());
      // Hard redirect so the user never stays on a broken / JSON error screen.
      if (!onAuthPage && (result.redirectToAuth || result.status === 'unauthorized' || result.status === 'client_error')) {
        redirectToAuth();
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!session.checked) {
    return (
      <ThemeProvider theme={customTheme}>
        <div />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={customTheme}>
      {width >= 1000 ? (
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                session.authenticated ? <MainPage /> : <Navigate to="/auth" replace />
              }
            />
            <Route
              path="/auth"
              element={
                session.authenticated ? <Navigate to="/" replace /> : <Auth />
              }
            />
            <Route path="*" element={<Navigate to={session.authenticated ? "/" : "/auth"} replace />} />
          </Routes>
        </Router>
      ) : (
        <Mobile />
      )}
    </ThemeProvider>
  );
}

export default App;
